export const ORIENTATIONS = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait'
}

export const POPUP_AUTO_PROCEED_TIME = 30000; // in millisecond
